module.exports = __webpack_public_path__ + "static/surcos.c8e18e93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surcos.jpg
// module id = 1498
// module chunks = 256810187883326